import React, { FC } from 'react';
import './FeaturesList.scss';
import { IFeatureListProps } from './models';
import DangerouslySetInnerHtml from 'components/common/DangerouslySetInnerHtml';
import ProductCarousel from '../ProductCarousel';
import { CarouselMasks } from '../ProductCarousel/models';
import CardBox from '../CardBox';
import HTag from '../HTag';
import classNames from 'classnames';

const FeaturesList: FC<IFeatureListProps> = ({
  titleRegular,
  titleBold,
  description,
  background,
  items,
  textColor,
  cssClassName,
}) => {
  const classes = classNames('features-list', cssClassName);

  return (
    <div
      className={classes}
      style={{
        background: background ? background : 'none',
      }}
    >
      <div
        style={{
          color: textColor ? textColor : 'inherit',
        }}
        className="features-list-content"
      >
        <HTag
          underline
          size={2}
          regularText={titleRegular}
          color={textColor}
          boldText={titleBold}
        />
        <DangerouslySetInnerHtml html={description} element="p" />
        <ProductCarousel
          partialVissible={false}
          type={CarouselMasks.noMasks}
          infinite={false}
          limitWidth={false}
          isBtnGroup={true}
        >
          {items.map((item, index) => (
            <CardBox
              key={index}
              image={item.properties.featureImage}
              imageAlt={item.properties.featureImage.altText}
              title={item.properties.featureTitle}
              intro={item.properties.featureDescription}
              large={false}
              expandText={item.properties.expandText}
            />
          ))}
        </ProductCarousel>
      </div>
    </div>
  );
};

export default FeaturesList;
